import * as permissions from './Permissions'
import { Roles } from '@cbgms/api/modules/enums'

const NoPermissions: string[] = []

const AdminPermissions: string[] = [
  permissions.PERMISSION_APP_ACCESS,
  permissions.PERMISSION_MANAGE_COMPANIES,
  permissions.PERMISSION_MANAGE_SHOPS,
  permissions.PERMISSION_MANAGE_STATS,
  permissions.PERMISSION_TROUBLESHOOT,
  permissions.PERMISSION_MANAGE_CONCEPTS,
  permissions.PERMISSION_MANAGE_THEMES,
  permissions.PERMISSION_MANAGE_PRODUCT_GROUPS,
  permissions.PERMISSION_MANAGE_WHOLESALERS,
  permissions.PERMISSION_MANAGE_WARRANTY,
  permissions.PERMISSION_MANAGE_LICENSES,
  permissions.PERMISSION_CACHE,
  permissions.PERMISSION_DEV_SETTINGS,
  permissions.PERMISSION_RELEASE_NOTES,
  permissions.PERMISSION_MANAGE_TRANSLATIONS,
  permissions.PERMISSION_MANAGE_BANK_HOLIDAYS,
  permissions.PERMISSION_MANAGE_REGIONS,
  permissions.PERMISSION_MANAGE_EXTERNAL_GMS,
  permissions.PERMISSION_MANAGE_MESSAGES,
  permissions.PERMISSION_MANAGE_SHOP_EMPLOYEES,
  permissions.PERMISSION_MANAGE_EXTERNAL_SYSTEMS,
  permissions.PERMISSION_TELESALES,
  permissions.PERMISSION_LESSOR_AND_CONCEPT,
  permissions.PERMISSION_MANAGE_ROAD_ASSISTANCE,
  permissions.PERMISSION_MANAGE_CONCEPT_CONFIGURATION
]

const SupportDeskPermissions: string[] = [
  permissions.PERMISSION_APP_ACCESS,
  permissions.PERMISSION_MANAGE_COMPANIES,
  permissions.PERMISSION_MANAGE_SHOPS,
  permissions.PERMISSION_MANAGE_STATS,
  permissions.PERMISSION_TROUBLESHOOT,
  permissions.PERMISSION_MANAGE_SHOP_EMPLOYEES,
  permissions.PERMISSION_MANAGE_EXTERNAL_SYSTEMS
]

const LKQConceptManagerPermissions: string[] = [
  permissions.PERMISSION_APP_ACCESS,
  permissions.PERMISSION_MANAGE_COMPANIES,
  permissions.PERMISSION_MANAGE_SHOPS,
  permissions.PERMISSION_MANAGE_STATS,
  permissions.PERMISSION_MANAGE_CONCEPTS,
  permissions.PERMISSION_MANAGE_THEMES,
  permissions.PERMISSION_MANAGE_SHOP_EMPLOYEES,
  permissions.PERMISSION_MANAGE_EXTERNAL_SYSTEMS,
  permissions.PERMISSION_MANAGE_CONCEPT_CONFIGURATION
]

const LKQProductManagerPermissions: string[] = [
  permissions.PERMISSION_APP_ACCESS,
  permissions.PERMISSION_MANAGE_COMPANIES,
  permissions.PERMISSION_MANAGE_SHOPS,
  permissions.PERMISSION_MANAGE_STATS,
  permissions.PERMISSION_MANAGE_PRODUCT_GROUPS,
  permissions.PERMISSION_MANAGE_WHOLESALERS,
  permissions.PERMISSION_MANAGE_WARRANTY,
  permissions.PERMISSION_MANAGE_LICENSES,
  permissions.PERMISSION_MANAGE_SHOP_EMPLOYEES,
  permissions.PERMISSION_MANAGE_EXTERNAL_SYSTEMS
]

const TelesalesPermissions: string[] = [
  permissions.PERMISSION_APP_ACCESS,
  permissions.PERMISSION_TELESALES,
  permissions.PERMISSION_MANAGE_WARRANTY
]

const LessorAndConceptPermissions: string[] = [permissions.PERMISSION_APP_ACCESS, permissions.PERMISSION_LESSOR_AND_CONCEPT]

const DACHTelesalesPermissions: string[] = [
  permissions.PERMISSION_APP_ACCESS,
  permissions.PERMISSION_NEW_CUSTOMERT_ACQUISITION,
  permissions.PERMISSION_CUSTOMER_PROFILE
]

const DACHTelesalesSupervisorPermissions: string[] = [
  permissions.PERMISSION_APP_ACCESS,
  permissions.PERMISSION_NEW_CUSTOMERT_ACQUISITION,
  permissions.PERMISSION_CUSTOMER_PROFILE
]

const DACHSuperUserPermissions: string[] = [
  permissions.PERMISSION_APP_ACCESS,
  permissions.PERMISSION_NEW_CUSTOMERT_ACQUISITION,
  permissions.PERMISSION_CUSTOMER_PROFILE,
  permissions.PERMISSION_EDIT_CUSTOMER_PROFILE_HAMBURGER_MENU,
  permissions.PERMISSION_CUSTOMER_FUNCTIONAL_FLAG_MANAGEMENT,
  permissions.PERMISSION_CUSTOMER_EMAIL_CONTENT,
  permissions.PERMISSION_CUSTOMER_EMAIL_ATTACHMENT,
  permissions.PERMISSION_CUSTOMER_PENDING_EMAIL,
  permissions.MODULE_MANAGEMENT_FLAG_MANAGEMENT,
  permissions.PERMISSION_CUSTOMER_OFFER,
  permissions.PERMISSION_CUSTOMER_ALERTS,
  permissions.PERMISSION_ADMIN_UI_CONFIG,
  permissions.PERMISSION_RESET_USER_PROFILE_HAMBURGER_MENU
]

const DACHSupportDeskPermissions: string[] = [
  permissions.PERMISSION_APP_ACCESS,
  permissions.PERMISSION_NEW_CUSTOMERT_ACQUISITION,
  permissions.PERMISSION_CUSTOMER_PROFILE,
  permissions.PERMISSION_EDIT_CUSTOMER_PROFILE_HAMBURGER_MENU,
  permissions.PERMISSION_CUSTOMER_PENDING_EMAIL
]

const DACHSupportAdminPermissions: string[] = [
  permissions.PERMISSION_APP_ACCESS,
  permissions.PERMISSION_NEW_CUSTOMERT_ACQUISITION,
  permissions.PERMISSION_CUSTOMER_PROFILE,
  permissions.PERMISSION_EDIT_CUSTOMER_PROFILE_HAMBURGER_MENU,
  permissions.PERMISSION_CUSTOMER_EMAIL_CONTENT,
  permissions.PERMISSION_CUSTOMER_EMAIL_ATTACHMENT,
  permissions.PERMISSION_CUSTOMER_PENDING_EMAIL,
  permissions.PERMISSION_CUSTOMER_OFFER,
  permissions.PERMISSION_CUSTOMER_ALERTS
]

const DACHMarketingPermissions: string[] = [permissions.PERMISSION_APP_ACCESS, permissions.PERMISSION_CUSTOMER_OFFER]

export const RolePermissions: { [key in Roles]: string[] } = {
  [Roles.None]: NoPermissions,
  [Roles.Admin]: AdminPermissions,
  [Roles.SupportDesk]: SupportDeskPermissions,
  [Roles.LKQConceptManager]: LKQConceptManagerPermissions,
  [Roles.LKQProductManager]: LKQProductManagerPermissions,
  [Roles.Telesales]: TelesalesPermissions,
  [Roles.LessorAndConcept]: LessorAndConceptPermissions,
  [Roles.DACHTelesales]: DACHTelesalesPermissions,
  [Roles.DACHTelesalesSupervisor]: DACHTelesalesSupervisorPermissions,
  [Roles.DACHSupportAdmin]: DACHSupportAdminPermissions,
  [Roles.DACHSuperUser]: DACHSuperUserPermissions,
  [Roles.DACHSupportDesk]: DACHSupportDeskPermissions,
  [Roles.DACHMarketing]: DACHMarketingPermissions
}
